// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-carousel__item{display:block;position:relative}.czt-carousel__item__title{color:#178fcf;font-weight:500;margin-top:.75rem;font-size:1.375rem}.czt-carousel__item__information{color:#fff;font-size:1rem;font-weight:500;text-shadow:0 0 6px rgba(0,0,0,.8)}", ""]);
// Exports
module.exports = exports;
